// extracted by mini-css-extract-plugin
export var option = "_8y-0";
export var optionCard = "_8y-f";
export var optionContent = "_8y-g";
export var optionIcon = "_8y-i";
export var optionIconBox = "_8y-h";
export var optionLabel = "_8y-j";
export var optionPill = "_8y-m";
export var optionPillBadge = "_8y-p";
export var optionPillIcon = "_8y-n";
export var optionPillLabel = "_8y-o";
export var optionRadio = "_8y-k";
export var optionRadioInner = "_8y-l";
export var optionReveal = "_8y-2";
export var optionRevealDelay0 = "_8y-3";
export var optionRevealDelay1 = "_8y-4";
export var optionRevealDelay10 = "_8y-d";
export var optionRevealDelay11 = "_8y-e";
export var optionRevealDelay2 = "_8y-5";
export var optionRevealDelay3 = "_8y-6";
export var optionRevealDelay4 = "_8y-7";
export var optionRevealDelay5 = "_8y-8";
export var optionRevealDelay6 = "_8y-9";
export var optionRevealDelay7 = "_8y-a";
export var optionRevealDelay8 = "_8y-b";
export var optionRevealDelay9 = "_8y-c";
export var optionSelected = "_8y-1";